import * as React from "react";
import QueryPreservingLink from "../components/QueryPreservingLink";
import BaseLayout from "../layout/base/BaseLayout";
import { GatsbyImage } from "gatsby-plugin-image";
import { Box, Stack, useTheme } from "@mui/material";
import { graphql } from "gatsby";
import { get, head } from "lodash";
import Seo from "../components/Seo";

const NotFoundPage = ({ data }) => {
  const section = head(data.prismicPage.data.body);
  const theme = useTheme();

  return (
    <BaseLayout>
      <Stack
        sx={{
          alignItems: "center",
          px: "20px",
        }}
      >
        <Box
          component={GatsbyImage}
          image={section.primary.section_image.gatsbyImageData}
          alt={section.primary.section_image.alt || ""}
          sx={{
            marginTop: "50px",
            width: { xs: "320px", sm: "457px" },
            objectFit: "contain",
          }}
        />

        <Box
          component={QueryPreservingLink}
          sx={{
            margin: "47px 0",
            padding: "24px 50px",
            backgroundColor: theme.palette.primary.main,
            color: "#ffffff",
            fontWeight: "bold",
            fontSize: "18px",
            textTransform: "uppercase",
            textDecoration: "none",
            borderRadius: "36.5px",
          }}
          to="/"
        >
          {section.primary.section_cta_text.text}
        </Box>
      </Stack>
    </BaseLayout>
  );
};

export default NotFoundPage;

export const Head = (queryResult) => {
  const meta = get(queryResult, ["data", "prismicPage", "data", "meta"], {});

  return <Seo meta={meta} />;
};

export const pageQuery = graphql`
  {
    allSitePage {
      edges {
        node {
          path
        }
      }
    }
    prismicPage(uid: { eq: "not-found" }) {
      data {
        body {
          __typename
          ... on PrismicPageDataBodySection {
            primary {
              section_image {
                alt
                copyright
                url
                gatsbyImageData(layout: FULL_WIDTH)
              }
              section_cta_text {
                text
              }
            }
          }
        }
      }
    }
  }
`;
